// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Message20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Message20: FC<Message20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M3.5 16c-.413 0-.766-.147-1.06-.44A1.446 1.446 0 0 1 2 14.5V5.493c0-.413.147-.765.44-1.056A1.45 1.45 0 0 1 3.5 4h13c.413 0 .766.147 1.06.44.293.295.44.648.44 1.06v9.006c0 .413-.147.765-.44 1.056A1.45 1.45 0 0 1 16.5 16h-13Zm6.5-5L3.5 7.27v7.23h13V7.27L10 11Zm0-1.77 6.5-3.73h-13L10 9.23ZM3.5 7.27V5.5v9-7.23Z" />
        </svg>
    );
};

export default Message20;
